import http from "./http";

export interface UserRead {
  id: string;
  name: string;
  email: string;
  provider: "local" | "google" | "microsoft";
  active: boolean;
  roles: ("admin" | "user_manager" | "shift" | "tax" | "user")[];
  created_at: string;
  last_login: string | null;
}

export interface UserPage {
  total: number;
  page: number;
  size: number;
  prev: string | null;
  next: string | null;
  items: UserRead[];
}

export interface UserCreate {
  name: string;
  email: string;
  provider: "local" | "google" | "microsoft";
  password?: string;
}

export interface UserUpdate {
  name?: string;
  email?: string;
  password?: string;
  active?: boolean;
}

const BASE = "/tgc-users/users";

export const usersApi = {
  list: (page: number, size: number) =>
    http.get<UserPage>(`${BASE}?page=${page}&size=${size}`).then((r) => r.data),

  create: (body: UserCreate) =>
    http.post<UserRead>(BASE, body).then((r) => r.data),

  update: (id: string, body: UserUpdate) =>
    http.patch<UserRead>(`${BASE}/${id}`, body).then((r) => r.data),

  get: (identifier: string) =>
    http.get<UserRead>(`${BASE}/${identifier}`).then((r) => r.data),

  addRole: (id: string, role: string) =>
    http.post(`${BASE}/${id}/roles`, { role }).then((r) => r.data),

  removeRole: (id: string, role: string) =>
    http.delete(`${BASE}/${id}/roles/${role}`),
};
